/* global window document pymChild */

import './styles/graphic.scss';
import * as axios from 'axios';
import { Child } from 'pym.js';
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'regenerator-runtime/runtime';
import data from './data/data';

const testing = false;

// ////// ENTER URL for data processed by cronbot
let map_data_url = 'https://ix.cnn.io/data/snow-reports/latest.json';

// ////// ENTER details for map styles
const config = {
  style: 'mapbox://styles/cnndigital/cm60yi84g005q01st6forcbsa',
  default_zoom: 3.2,
};

// >> ENTER graphic slug, with date ... ie "20210908-stream-flood-tracker"
const graphic_slug = '20220128-snow-reports-live';

// date
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('America/New_York');
dayjs.extend(updateLocale);
dayjs.updateLocale('en', {
  monthsShort: [
    'Jan.', 'Feb.', 'March', 'April', 'May', 'June',
    'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.',
  ],
  meridiem: (hour, minute, isLowercase) => (hour >= 12 ? 'p.m.' : 'a.m.'),
});

// Mapbox
const mapboxgl = require('mapbox-gl');

const MAPBOX_TOKEN = 'pk.eyJ1IjoiY25uZGlnaXRhbCIsImEiOiJja2V1M3Vyd3kwMDZrMnF0Njdhb3ZhZDk5In0.OURIYzTcS6ZzoWjXJzfANg';
const defaultCenter = [-95.7129, 39];
let map;
let mapParams;
let hasLocation;
let outageEvent;
let warningNote;


// instantiate pym object
window.pymChild = new Child();

// check for URL params
function checkParams() {
  // use the parent URL if we're using the "parent.html" preview page
  // otherwise use the straight url
  let url;
  if ((pymChild.parentUrl) && (pymChild.parentUrl.indexOf('/parent.html') !== -1)) {
    url = pymChild.parentUrl;
  } else {
    url = window.location.href;
  }

  console.log('Parent url:', pymChild.parentUrl);
  console.log('Using url:', url);

  // Parse params
  const getParams = function (url) {
    const params = {};
    const parser = document.createElement('a');
    parser.href = url;
    const query = parser.search.substring(1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=');
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
  };

  const splitMbhash = (text) => {
    let hasharray = [];
    hasharray = text.split('/').map(Number);
    return hasharray;
  };

  mapParams = getParams(url);
  if ('lnglat' in mapParams) {
    mapParams.lnglat = [parseFloat(mapParams.lnglat.split(',')[0]), parseFloat(mapParams.lnglat.split(',')[1])];
  }
  if ('z' in mapParams) {
    mapParams.z = parseFloat(mapParams.z);
  }
  if ('l' in mapParams) {
    mapParams.l = mapParams.l.split(',');
  }


  if ('event' in mapParams) {
    const find_event = data.filter(d => d.event_code == mapParams.event);

    if (find_event) {
      outageEvent = find_event[0];
    }

    if (find_event.length == 0) {
      warningNote = 'WARNING: Event ID in URL isn\'t listed in the spreadsheet. Using default view.';
    }

    if (outageEvent && outageEvent.map_view) {
      mapParams.mbhash = outageEvent.map_view;
      console.log('using event', mapParams.event);
    }

    if (outageEvent && outageEvent.freeze && outageEvent.freeze.toLowerCase().trim() == 'yes' && outageEvent.freeze_name) {
      mapParams.dailies = outageEvent.freeze_name;
    }
  }


  if ('mbhash' in mapParams) {
    const parsedHash = splitMbhash(mapParams.mbhash);
    mapParams.z = parsedHash[0];
    mapParams.lnglat = [parsedHash[2], parsedHash[1]];
  }

  if ('dailies' in mapParams) {
    map_data_url = `https://ix.cnn.io/data/snow-reports/archive/${mapParams.dailies}.json`;
  }

  // Set params to true if they have what we want (zoom + lng/lat)
  hasLocation = !!('lnglat' in mapParams && 'z' in mapParams);
}

export default function (props, container, isMobile, meta) {
  // function to get the latest map data
  const fetchData = async (data_url) => {
    const response = await axios.get(data_url);
    return response.data;
  };

  // function to draw the map
  const drawMap = (mapdata) => {
    const {
      initialWidth,
      initialHeight,
      // width,
      // height,
    } = props;

    let legend_title;
    if (!mapParams.dailies) {
      // strange since time for this map
      legend_title = 'Snow amount, in inches';
    } else {
      legend_title = 'Snow amount, in inches';
    }

    // // -- legend code -- // //

    const color_width = 35; // width in pixels
    const breaks = [1, 3, 5, 10, 15, 20, '30 in.'];

    const colors = ['#efedf5', '#dadaeb', '#bcbddc', '#9e9ac8', '#807dba', '#6a51a3', '#54278f', '#3f007d'];

    // assumes a previously-established container div
    container
      .append('div')
      .attr('class', 'v-legend-hed')
      .html(legend_title);

    const map_legend = container
      .append('div')
      .attr('class', 'v-legend-colors-container')
      .attr('width', initialWidth);

    map_legend.selectAll('.v-legend-colors')
      .data(colors)
      .enter()
      .append('div')
      .attr('class', 'v-legend-colors')
      .style('height', '8px')
      .style('width', `${color_width}px`)
      .style('background-color', d => d);

    const map_legend_labels = container
      .append('div')
      .attr('class', 'v-legend-labels-container')
      .attr('width', initialWidth);

    map_legend_labels
      .append('div')
      .attr('class', 'v-legend-label-spacer')
      .style('width', `${color_width / 2}px`);

    map_legend_labels.selectAll('.v-legend-labels')
      .data(breaks)
      .enter()
      .append('div')
      .attr('class', 'v-legend-labels')
      .style('width', `${color_width}px`)
      .html(d => d);

    map_legend_labels
      .append('div')
      .attr('class', 'v-legend-label-spacer')
      .style('width', `${color_width / 2}px`);

    // // -- Map drawing -- // //

    console.log('using cnnvis-cronbot data:', map_data_url);


    // complicated way to adjust the zoom depending on the
    // map size. could use more elegance.
    function getZoom() {
      let zoomLevel;
      if (hasLocation) {
        zoomLevel = isMobile ? mapParams.z - 1 : mapParams.z;
      } else if (initialWidth >= 900) {
        zoomLevel = config.default_zoom + 0.25;
      } else if (initialWidth <= 320) {
        zoomLevel = 2.1;
      } else {
        zoomLevel = isMobile ? config.default_zoom - 1 : config.default_zoom;
      }
      return zoomLevel;
    }


    // Draw the map
    container.append('div')
      .attr('class', 'map-container')
      .append('div')
      .attr('id', 'map')
      .attr('width', initialWidth)
      .attr('height', initialHeight);

    // Dynamic footer
    const { as_of } = mapdata; // Access 'as_of' directly
    console.log(as_of);

    // Append the formatted footer
    container.append('div')
      .attr('class', 'v-dynamic-footnote')
      .html(`&nbsp;<br>${meta.footnote} Data as of ${as_of.trim()}.`);

    mapboxgl.accessToken = MAPBOX_TOKEN;
    map = new mapboxgl.Map({
      container: 'map',
      style: config.style,
      projection: { name: 'albers' },
      center: hasLocation ? mapParams.lnglat : defaultCenter,
      zoom: getZoom(),
      maxZoom: 9,
      minZoom: 2,
      //   Interactive disabled
      pitchWithRotate: false,
      scrollZoom: false,
      dragRotate: false,
      touchPitch: false,
      interactive: true,
    });

    // zoom buttons
    const nav = new mapboxgl.NavigationControl({
      showCompass: false,
    });
    map.addControl(nav, 'top-right');

    // ////// LOAD YOUR DATA GEOJSON HERE /////////

    map.on('load', () => {
      map.addSource('snowreport', {
        type: 'geojson',
        data: mapdata,
      });

      map.addLayer({
        id: 'snowreport',
        source: 'snowreport',
        type: 'circle',
        paint: {
          'circle-color': ['get', 'fill'],
          'circle-radius': [
            'interpolate',
            // Set the exponential rate of change to 0.5
            ['exponential', 0.5],
            ['zoom'],
            // When zoom is 6, circles will be 6
            4,
            5,
            // When zoom is 6, circles will be 6
            6,
            7,
            // When zoom is 7, circles will be 8
            7,
            8,
            // When zoom is 8 or higher, circles will be 10.
            8,
            10,
          ],
          'circle-opacity': [
            'interpolate',
            // Set the exponential rate of change to 0.5
            ['linear'],
            ['zoom'],
            // When zoom is below 7, opacity will be 0.7
            5,
            0.8,
            // When zoom is 8, opacity will be 1
            8,
            1,
          ],
        },

      // Layer in the style stack under which this layer should be drawn
      // (We're using waterway-label, which is below all the state and city names)
      }, 'waterway-label');
    });


    // // -- popup code -- // //

    // Create a popup, but don't add it to the map yet.
    const popup = new mapboxgl.Popup({
      closeButton: false,
      closeOnClick: false,
    });

    // populate and show the popup
    map.on('mousemove', 'snowreport', (e) => {
      // // don't do at high zoom levels
      // if (map.getZoom() < 5) {
      //   return;
      // }

      // Change the cursor style as a UI indicator.
      map.getCanvas().style.cursor = 'pointer';

      // Get the latlon of the mouse position
      const coordinates = e.lngLat;

      // Build the info we're going to display
      const { location } = e.features[0].properties;
      // const remarks = e.features[0].properties.remarks;
      const { state } = e.features[0].properties;
      const timestamp = e.features[0].properties.valid_time;
      const time = dayjs.unix(timestamp).tz('America/New_York').format('MMM D [at] h:mm a [ET]');
      const { amount } = e.features[0].properties;
      const { amount_val } = e.features[0].properties;

      const popup_html = `<div class='v-popup'><div class='v-popup-type'>${location}, ${state}</div><div class='v-popup'><div class='v-popup-type'>${amount} ${(amount_val == 1) ? 'inch' : 'inches'}</div><div class='v-popup-description'>${time}</div>`;

      // Populate the popup and set its coordinates
      // based on the feature found.
      popup.setLngLat(coordinates).setHTML(popup_html).addTo(map);
    });

    // remove the popup
    map.on('mouseleave', 'snowreport', () => {
      // unstyle the cursor
      map.getCanvas().style.cursor = '';

      // remove the popup
      popup.remove();
    });


    // /////// THIS PUTS EMBED CODES INTO THE CONSOLE LOG ////////
    // Note that these are removed in the

    map.on('idle', () => {
      console.log('- - - - - - - - - -');
      const current_lon = map.getCenter().lng.toFixed(4);
      const current_lat = map.getCenter().lat.toFixed(4);
      const current_zoom = map.getZoom().toFixed(2);
      let new_params = `?lnglat=${current_lon},${current_lat}&z=${current_zoom}`;
      if (mapParams.event) {
        new_params = `?event=${mapParams.event}`;
      }
      console.log('DLE link:');
      console.log(`https://ix.cnn.io/dailygraphics/graphics/${graphic_slug}/index.html${new_params}`);
      console.log('Web tag:');
      console.log(`<div id="responsive-embed-${graphic_slug}"></div>
      <script>
      if(!window.pym){(function(b,c){var d=document.createElement("script");d.type="text/javascript",d.readyState?d.onreadystatechange=function(){("loaded"===d.readyState||"complete"===d.readyState)&&(d.onreadystatechange=null,c())}:d.onload=function(){c()},d.src=b,document.getElementsByTagName("head")[0].appendChild(d)})("//cdn.cnn.com/cnn/.e/interactive/js/lib/vendor/pym/pym.v1.min.js",function(){new pym.Parent("responsive-embed-${graphic_slug}","//ix.cnn.io/dailygraphics/graphics/${graphic_slug}/index.html${new_params}",{title:"CNN Graphic"})})}else var responsiveEmbed=new pym.Parent("responsive-embed-${graphic_slug}","//ix.cnn.io/dailygraphics/graphics/${graphic_slug}/index.html${new_params}",{title:"CNN Graphic"});
      </script>`);
      console.log('map_view:');
      console.log(`${current_zoom}/${current_lat}/${current_lon}   (zoom/lat/lon)`);
      if (warningNote) {
        console.log(warningNote);
      }
    });

    // update height of svg to pym
    pymChild.sendHeight();
  };

  // // check url params
  checkParams();

  if (testing) {
    drawMap(testdata.default);
  } else {
    // fetch data and draw the map
    fetchData(map_data_url).then(drawMap);
  }
}
